import React, { useRef, useState } from 'react'

import * as styles from './styles.module.scss'

import icon from '../../images/icons/chevrone-bottom.svg'
import translate from '../../helpers/Translate'

const ShopPrices = ({ shopPrices, allShops, opretShopBar }) => {

    const shopsRef = useRef( [] ) 

    const [ showMore, setShowMore ] = useState( false )

    let scrappedShops = JSON.parse( shopPrices )

    let shops = []

    opretShopBar?.forEach(item => {
      allShops?.shopLinks?.forEach(shop => {

        if (shop.name === "Noshop") {
          return
        }

        if (shop.name === item.vaelgShop) {

          let hasSale = false

          let scrapped_data = scrappedShops?.find(
            scShop => scShop.name === item.vaelgShop
          )

          if (scrapped_data === undefined) {
            scrapped_data = { price_regular: 0, price_sale: 0 }
          }

          if ( scrapped_data.price_regular !== scrapped_data.price_sale ) {
            hasSale = true
          }

          if (shop.affLink !== null) {
            shops.push({
              ...shop,
              link: shop.affLink + item.link,
              price: Math.round(scrapped_data.price_regular),
              price_sale: Math.round(scrapped_data.price_sale),
              hasSale,
            })
          }

          if (shop.affLinkEnd !== null) {
            shops.push({
              ...shop,
              link: item.link + shop.affLinkEnd,
              price: Math.round(scrapped_data.price_regular),
              price_sale: Math.round(scrapped_data.price_sale),
              hasSale,
            })
          }
          
        }
      })
    })

    const copyCouponNameToClipboard = ( name, id ) => {

        navigator.clipboard.writeText( name )

        shopsRef.current[id].querySelector(`.${styles.coupon} .${styles.copied}`).classList.add( styles.active )

        const timer = setTimeout(() => {
            shopsRef.current[id].querySelector(`.${styles.coupon} .${styles.copied}`).classList.remove( styles.active )
        }, 2000 )

        return () => clearTimeout( timer )

    }

    const lang = process.env.GATSBY_SITE_LANG

    const difference = shops.length - 3

    const seeMoreShopsLable = shops.length > 3 ? difference === 1 ? 
    lang === 'en' ? `See ${difference} more Shop` : 'Einen weiteren Shop anzeigen' : 
    lang === 'en' ? `See ${difference} more Shops` : `${difference} weitere Shops anzeigen` : `See Less Shops`

    return (
      <div className={styles.prices}>
        {shops.map(
          (shop, id) =>
            <div className={styles.shop} style={{ display : id < 3 || showMore ? '' : 'none' }} key={shop.name} ref={ el => shopsRef.current[id] = el }>

              <div className={styles.shop__name}>
                <span>{ shop?.alternativeName ?  shop.alternativeName : shop.name}</span>
                {shop.couponName && (
                  <div className={styles.coupon}>
                    <span className={styles.label}>
                      {shop.couponPercentage}% off w/
                    </span>
                    <span className={styles.code} onClick={() => copyCouponNameToClipboard( shop.couponName, id )}>{shop.couponName}</span>
                    <span className={styles.copied}>Copied</span>
                  </div>
                )}
              </div>

              <div className={styles.shop_actions}>
                <div className={`${styles.price} ${ shop.hasSale ? styles.has__coupon : "" }`}>
                  {shop.hasSale && <span className={styles.coupon}>${shop?.price}</span>}
                  <span className={styles.regular}>
                    {shop.price === 0 ? '' : `$${shop.hasSale ? shop.price_sale : shop?.price}`}
                  </span>
                </div>
                <a
                  href={shop.link}
                  target="_blank"
                  rel="sponsored"
                  className={styles.action__btn}
                >
                  {translate('See Deal')}
                </a>
              </div>
            </div>
        )}
        {shops.length > 3 && (
          <div className={styles.show__more__btn} style={{ margin : showMore ? '-20px auto 0' : '' }}>
            <span
              onClick={() => setShowMore(!showMore)}
              className={showMore ? styles.active : ""}
            >
              {showMore
                ? translate("See Less Shops")
                : translate( seeMoreShopsLable )}
              <img src={ icon } alt={ translate( "See More Shops" ) } />
            </span>
          </div>
        )}
      </div>
    )
}

export default ShopPrices